export const DEFAULT_FOUNDING_AGENT_SERVICE_URL = "https://service.usemoss.dev";
// Shared request timeout for control-plane calls (session minting, intake
// submit). Keeps every fetch from hanging indefinitely on a stalled endpoint.
export const FOUNDING_AGENT_REQUEST_TIMEOUT_MS = 10_000;
function stripTrailingSlashes(s) {
    return s.replace(/\/+$/, "");
}
export function parseSessionResponse(json) {
    const o = (json ?? {});
    const token = typeof o.token === "string" ? o.token : "";
    const serverUrl = (typeof o.serverUrl === "string" && o.serverUrl) ||
        (typeof o.server_url === "string" && o.server_url) || "";
    const roomName = (typeof o.roomName === "string" && o.roomName) ||
        (typeof o.room_name === "string" && o.room_name) || "";
    const bookingNonce = (typeof o.bookingNonce === "string" && o.bookingNonce) ||
        (typeof o.booking_nonce === "string" && o.booking_nonce) || null;
    if (!token || !serverUrl) {
        throw new Error("Session response must include { token, serverUrl }");
    }
    return { token, serverUrl, roomName, bookingNonce };
}
async function postJson(url, timeoutMs = FOUNDING_AGENT_REQUEST_TIMEOUT_MS) {
    const ctrl = new AbortController();
    const timer = setTimeout(() => ctrl.abort(), timeoutMs);
    try {
        const res = await fetch(url, { method: "POST", signal: ctrl.signal });
        if (!res.ok) {
            const body = await res.text().catch(() => "");
            throw new Error(`Session endpoint ${res.status}: ${body}`);
        }
        return await res.json();
    }
    finally {
        clearTimeout(timer);
    }
}
export async function createPublicSession(opts) {
    const base = stripTrailingSlashes(opts.serviceUrl ?? DEFAULT_FOUNDING_AGENT_SERVICE_URL);
    const url = `${base}/api/founding-agent/public/sessions?key=${encodeURIComponent(opts.publishableKey)}`;
    return parseSessionResponse(await postJson(url, opts.timeoutMs));
}
export async function createSessionViaEndpoint(tokenEndpoint, timeoutMs) {
    return parseSessionResponse(await postJson(tokenEndpoint, timeoutMs));
}
